
import React from 'react';
import PaymentOption from './PaymentOption';
import { Invoice } from '@/components/InvoiceList';

interface PaymentSectionProps {
  invoice: Invoice;
  selectedPaymentMethod: 'bank' | 'card';
  handlePaymentMethodSelect: (method: 'bank' | 'card') => void;
  handlePaymentSubmit: () => void;
  showProcessingFee: (type: 'bank' | 'card') => boolean;
  getProcessingFee: (amount: number, type: 'bank' | 'card') => number;
  chargeAchFees: boolean;
  formatCurrency: (value: number) => string;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({
  invoice,
  selectedPaymentMethod,
  handlePaymentMethodSelect,
  handlePaymentSubmit,
  showProcessingFee,
  getProcessingFee,
  chargeAchFees,
  formatCurrency
}) => {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold mb-4 gradient-text">How would you like to pay?</h2>
      
      <PaymentOption
        type="bank"
        isSelected={selectedPaymentMethod === 'bank'}
        invoice={invoice}
        onSelect={handlePaymentMethodSelect}
        onSubmit={handlePaymentSubmit}
        formatCurrency={formatCurrency}
        showProcessingFee={showProcessingFee}
        getProcessingFee={getProcessingFee}
        chargeAchFees={chargeAchFees}
      />
      
      <PaymentOption
        type="card"
        isSelected={selectedPaymentMethod === 'card'}
        invoice={invoice}
        onSelect={handlePaymentMethodSelect}
        onSubmit={handlePaymentSubmit}
        formatCurrency={formatCurrency}
        showProcessingFee={showProcessingFee}
        getProcessingFee={getProcessingFee}
        chargeAchFees={chargeAchFees}
      />
    </div>
  );
};

export default PaymentSection;
